import { render, staticRenderFns } from "./port-membership.vue?vue&type=template&id=c307f570&scoped=true"
import script from "./port-membership.vue?vue&type=script&lang=ts"
export * from "./port-membership.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c307f570",
  null
  
)

export default component.exports